import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheck, Clock, Cpu, ShieldCheck } from 'lucide-react';
import { SectionHeading, fadeUp } from './ServiceSections';
import data from '../data.json';

// reasonsList stores lucide-react icon names
const icons = { ClipboardCheck, Clock, Cpu, ShieldCheck };

const WhyChooseUsSection = () => {
  const { reasonsList } = data;

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 max-w-6xl">
        <SectionHeading
          title="Why Choose TPPES"
          description="What sets our team apart on every project, large or small."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasonsList.map((reason, index) => {
            const Icon = icons[reason.icon];
            return (
              <motion.div
                key={reason.id}
                {...fadeUp}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-lg shadow-lg p-6 border-t-4 border-custom-blue hover:shadow-xl transition-shadow duration-300"
              >
                <div className="bg-blue-50 w-12 h-12 rounded-full text-custom-blue flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {reason.title}
                </h3>
                <p className="text-gray-600">{reason.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
